module.exports = {
  stageName: process.env.REACT_APP_STAGE_NAME,
  refreshMinutes: process.env.REACT_APP_REFRESH_MINUTES,
  switchMinutes: process.env.REACT_APP_SWITCH_MINUTES,
  isTesting: process.env.REACT_APP_IS_TESTING,
  systemID: process.env.REACT_APP_SYSTEM_ID,
  apiGatewayURL: process.env.REACT_APP_APIGATEWAY_URL,
  timezone: '8',
};
